var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppPageContainer',{attrs:{"showNav":false,"clean":true,"background":'calendar'}},[_c('div',{staticClass:"homespace"},[_c('VueDraggableResizable',{staticStyle:{"border":"unset"},attrs:{"handles":[],"parent":true,"w":600,"h":700,"x":550,"y":150}},[_c('div',{staticClass:"widget"},[_c('HomespaceMyDay')],1)]),_c('HomespaceDock')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }